var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("AuctionsFilters", {
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters
        }
      }),
      _c(
        "div",
        {
          staticClass:
            "text-left mb-2 d-flex justify-content-start align-items-center"
        },
        [
          _vm.filteredAuctions.length
            ? _c(
                "div",
                { staticClass: "my-2 text-primary" },
                [
                  _c("b-form-checkbox", {
                    staticClass: "d-inline-block",
                    on: { change: _vm.selectAllAuctions },
                    model: {
                      value: _vm.selectAll,
                      callback: function($$v) {
                        _vm.selectAll = $$v
                      },
                      expression: "selectAll"
                    }
                  }),
                  _vm._v(" Seleccionar todos ")
                ],
                1
              )
            : _vm._e(),
          _c("AuctionsOptionsMasive", {
            attrs: { "selected-auctions": _vm.selectedAuctions }
          }),
          _c(
            "b-button",
            {
              staticClass: "badge-glow mb-2 ml-3",
              attrs: { variant: "warning", size: "sm", "data-cy": "download" },
              on: { click: _vm.onDownloadAuctions }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "DownloadIcon" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Descargar")])
            ],
            1
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED200",
                  expression: "'ED200'"
                }
              ],
              staticClass: "badge-glow ml-3 mb-2",
              attrs: {
                "data-cy": "auction-register",
                variant: "primary",
                size: "sm"
              },
              on: { click: _vm.openModalAuction }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "list" }
              }),
              _c("span", { staticClass: "align-middle" }, [
                _vm._v("Registrar subasta")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("AuctionsHeader"),
      _c(
        "div",
        { key: _vm.forceRender, staticClass: "force-render" },
        _vm._l(_vm.filteredAuctions, function(auction) {
          return _c("AuctionRow", {
            key: auction.subastaId,
            attrs: {
              "is-massive": _vm.isMassive,
              "selected-auctions": _vm.selectedAuctions,
              auction: auction,
              "select-auction": _vm.selectAuction
            },
            on: {
              "select-check-auction": _vm.selectCheckAuction,
              "unselect-check-auction": _vm.unSelectCheckAuction,
              "reload-list": _vm.handleReloadList
            }
          })
        }),
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "mt-5" }, [
            _vm._v(" Mostrando "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rowspp,
                    expression: "rowspp"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.rowspp = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      return _vm.fetchAuctions()
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "10", selected: "selected" } }, [
                  _vm._v("10")
                ]),
                _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
              ]
            ),
            _vm._v(" registros por página. ")
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-9" },
          [
            _c("AuctionsPagination", {
              attrs: { show: _vm.filteredAuctions.length },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          ref: "new-auction",
          attrs: {
            title: "Registro de subasta",
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.loadingCompanies } },
            [
              _c(
                "b-form",
                { attrs: { "data-vv-scope": "auction-form" } },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-3", attrs: { label: "Fecha subasta" } },
                    [
                      _c("date-picker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          name: "date",
                          format: "DD MMM YYYY",
                          "value-type": "YYYY-MM-DD",
                          type: "date",
                          "data-vv-as": "fecha de subasta",
                          placeholder: "Fecha de subasta",
                          "disabled-date": _vm.disabledMinDate,
                          "data-cy": "auction-date"
                        },
                        model: {
                          value: _vm.auction.date,
                          callback: function($$v) {
                            _vm.$set(_vm.auction, "date", $$v)
                          },
                          expression: "auction.date"
                        }
                      }),
                      _vm.errors.has("auction-form.date")
                        ? _c("div", [
                            _c("small", { staticClass: "text-danger" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.errors.first("auction-form.date")
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-3",
                      attrs: { label: "Aduana coordinadora" }
                    },
                    [
                      _c(
                        "v-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            options: _vm.customsCompanies,
                            name: "managingCustoms",
                            state: _vm.errors.has(
                              "auction-form.managingCustoms"
                            )
                              ? false
                              : null,
                            "data-vv-as": "aduana coordinadora",
                            danger: _vm.errors.has(
                              "auction-form.managingCustoms"
                            ),
                            "danger-text": _vm.errors.first(
                              "auction-form.managingCustoms"
                            )
                          },
                          model: {
                            value: _vm.auction.managingCustoms,
                            callback: function($$v) {
                              _vm.$set(_vm.auction, "managingCustoms", $$v)
                            },
                            expression: "auction.managingCustoms"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: { slot: "no-options" },
                              slot: "no-options"
                            },
                            [_vm._v(" No hay coincidencias ")]
                          )
                        ]
                      ),
                      _vm.errors.first("auction-form.managingCustoms")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger\n               vs-input--text-validation-span v-enter-to",
                              staticStyle: { height: "32px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " El campo aduana coordinadora es obligatorio "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "badge-glow ml-3 mb-5",
                  attrs: {
                    "data-cy": "save",
                    variant: "primary",
                    size: "sm",
                    disabled: _vm.disableAddAuctionButton
                  },
                  on: {
                    click: function($event) {
                      return _vm.attemptAddAuction()
                    }
                  }
                },
                [_vm._v(" Registrar ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }